import { Point, type Rect } from '@geom';
import RBush from 'rbush';

export enum SpatialIndexItemType {
  NODE,
  EDGE
}

export interface SpatialIndexItem {
  id: string;
  type: SpatialIndexItemType;
  bounds: Rect;
}

class MyRBush extends RBush<SpatialIndexItem> {
  toBBox(item: SpatialIndexItem) {
    return {
      minX: item.bounds.left,
      minY: item.bounds.top,
      maxX: item.bounds.right,
      maxY: item.bounds.bottom
    };
  }
  compareMinX(a: SpatialIndexItem, b: SpatialIndexItem) {
    return a.bounds.left - b.bounds.left;
  }
  compareMinY(a: SpatialIndexItem, b: SpatialIndexItem) {
    return a.bounds.top - b.bounds.top;
  }
}

export class SpatialIndex {
  index: MyRBush = new MyRBush();

  constructor(items: SpatialIndexItem[]) {
    this.index.load(items);
  }

  all(): SpatialIndexItem[] {
    return this.index.all();
  }

  query(area: Point | Rect): SpatialIndexItem[] {
    if (area instanceof Point) {
      return this.index.search({
        minX: area.x,
        minY: area.y,
        maxX: area.x,
        maxY: area.y
      });
    } else {
      return this.index.search({
        minX: area.left,
        minY: area.top,
        maxX: area.right,
        maxY: area.bottom
      });
    }
  }
}
